import { ReactNode, useEffect } from "react"
import posthog from "posthog-js"

export function PaymentTelemetryBoundary({ children }: { children: ReactNode }) {
  useEffect(() => {
    const recordingWasActive = posthog.sessionRecordingStarted()
    const recordingWasDisabled = posthog.config?.disable_session_recording ?? true
    posthog.stopSessionRecording()

    return () => {
      if (recordingWasActive) {
        posthog.startSessionRecording()
      } else if (!recordingWasDisabled) {
        // Restore configuration without forcing a sampled-out session to start.
        posthog.set_config({ disable_session_recording: false })
      }
    }
  }, [])

  return <div className="ph-no-capture contents">{children}</div>
}
